// extracted by mini-css-extract-plugin
module.exports = {"tag":"TagSelect_tag__TGxGA","tagActive":"TagSelect_tagActive__vIsg1"};